<script setup lang="ts">
import Button from "@/Components/Utils/Button.vue"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"
import { useFormatCurrency } from "@/Composables/useFormatCurrency"

interface PriceTier {
    min_quantity: number
    price: number
}

const props = defineProps<{
    form: any
    tiers: PriceTier[]
    errorPrefix: string
}>()

const tierError = (index: number, field: string): string | undefined =>
    props.form.errors[`${props.errorPrefix}.${index}.${field}`]

const groupError = (): string | undefined => props.form.errors[props.errorPrefix]

const clearTierError = (index: number, field: string) => {
    props.form.clearErrors(`${props.errorPrefix}.${index}.${field}`)
    props.form.clearErrors(props.errorPrefix)
}

const addTier = () => {
    const lastTier = props.tiers[props.tiers.length - 1]
    props.tiers.push({
        min_quantity: (lastTier?.min_quantity ?? 0) + 100,
        price: lastTier?.price ?? 0,
    })
    props.form.clearErrors(props.errorPrefix)
}

const removeTier = (index: number) => props.tiers.splice(index, 1)
</script>

<template>
    <div>
        <div class="flex flex-col gap-2">
            <div v-for="(tier, index) in tiers" :key="`tier-${index}`" class="flex items-end gap-x-3">
                <div class="flex-1">
                    <label class="mb-1 block text-xs text-gray-500">Qty minimal</label>
                    <input v-model.number="tier.min_quantity" type="number" min="0"
                        class="w-full rounded-md border-gray-300 text-sm"
                        :class="tierError(index, 'min_quantity') ? 'errorShake' : ''"
                        @input="clearTierError(index, 'min_quantity')" />
                </div>
                <div class="flex-1">
                    <label class="mb-1 block text-xs text-gray-500">Harga per pcs</label>
                    <input v-model.number="tier.price" type="number" min="0"
                        class="w-full rounded-md border-gray-300 text-sm"
                        :class="tierError(index, 'price') ? 'errorShake' : ''"
                        @input="clearTierError(index, 'price')" />
                </div>
                <div class="w-40 pb-2 text-xs text-gray-400">
                    qty &ge; {{ tier.min_quantity }} &rarr; {{ useFormatCurrency(tier.price) }}
                </div>
                <button v-if="tiers.length > 1" type="button" class="pb-2 text-gray-400 hover:text-red-500"
                    @click="removeTier(index)">
                    <FontAwesomeIcon icon="fal fa-times" fixed-width aria-hidden="true" />
                </button>
            </div>
        </div>

        <div class="mt-2 flex items-center justify-between">
            <div v-if="groupError()" class="text-xs text-red-500">{{ groupError() }}</div>
            <div v-else />
            <Button size="xs" type="secondary" icon="fal fa-plus" label="Tambah tingkat" @click="addTier" />
        </div>
    </div>
</template>
